import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n/lib';
import { Link } from 'react-router';
import { Button } from '../../Zemplin/General/Button';
import { ErrorAlert } from '../../Defaults/Alerts/ErrorAlert';
import { DsiInput as Input } from '../General/Input';
import { FormInput } from '../Form/FormInput';
import { TextP } from '../../..';
import { Select } from '../General/Select';

interface Props {
  lang: string;
  handleSubmit: any;
}

function ContactForm({ lang, handleSubmit }: Props) {
  React.useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      console.log('loading script');
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.onload = () => {
          if (callback) {
            callback();
          }
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) {
        callback();
      }
    };
    const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    // load the script by passing the URL
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`,
      () => undefined,
    );

    const removeScriptById = id => {
      const script = document.getElementById(id);
      const recaptchaBadge = document.getElementsByClassName(
        'grecaptcha-badge',
      )[0];
      if (script) {
        document.body.removeChild(script);
        if (recaptchaBadge) {
          recaptchaBadge.remove();
        }
      }
      return;
    };

    return () => {
      removeScriptById('recaptcha-key');
    };
  }, []);

  const [email, setEmail] = React.useState('');
  const [name, setName] = React.useState('');
  const [note, setNote] = React.useState('');
  const [type, setType] = React.useState('');

  const handleFormSubmit = e => {
    e.preventDefault();
    handleSubmit({ email, message: note, name, type }, e);
  };

  const handleSelectChange = e => {
    setType(e.target.value);
  };

  return (
    <Wrapper>
      {/* <div>{error && <ErrorAlert message={error} />}</div> */}
      <DescText>
        {__(
          'Cez tento formulár môžete uplatniť svoje práva súvisiace s ochranou Vašich osobných údajov.',
        )}
      </DescText>
      <Form
        // action={`${process.env.REACT_APP_API_BASE_URL}/contact-form`}
        method="POST"
        autoComplete="true"
        onSubmit={handleFormSubmit}
      >
        <Select
          marginBottom={32}
          marginRight={0}
          name="type"
          label={__('Typ požiadavky')}
          value={type}
          required={true}
          placeholder={__('Vyberte možnosť')}
          maxWidth={400}
          options={[
            {
              value: __('Žiadosť o informácie - aké údaje o mne spracovávate?'),
              name: __('Žiadosť o informácie - aké údaje o mne spracovávate?'),
            },
            {
              value: __('Žiadosť o opravu alebo doplnenie osobných údajov'),
              name: __('Žiadosť o opravu alebo doplnenie osobných údajov'),
            },
            {
              value: __('Žiadosť o vymazanie mojich osobných údajov'),
              name: __('Žiadosť o vymazanie mojich osobných údajov'),
            },
            {
              value: __('Žiadosť o obmedzenie spracovania osobných údajov'),
              name: __('Žiadosť o obmedzenie spracovania osobných údajov'),
            },
            {
              value: __('Sťažnosť k spracovaniu mojich osobných údajov'),
              name: __('Sťažnosť k spracovaniu mojich osobných údajov'),
            },
            {
              value: __('Iná požiadavka súvisiaca s osobnými údajmi'),
              name: __('Iná požiadavka súvisiaca s osobnými údajmi'),
            },
          ]}
          // tslint:disable-next-line:jsx-no-lambda
          onChange={handleSelectChange}
        />
        <FormInput
          type="text"
          value={name}
          required={true}
          name="name"
          // tslint:disable-next-line:jsx-no-lambda
          onChange={e => setName(e.target.value)}
          label={__('Meno a priezvisko')}
          maxWidthPx={400}
          marginRight={0}
        />
        <FormInput
          type="email"
          value={email}
          required={true}
          name="email"
          // tslint:disable-next-line:jsx-no-lambda
          onChange={e => setEmail(e.target.value)}
          label={__('E-mail')}
          maxWidthPx={400}
          marginRight={0}
        />
        <FormInput
          type="text"
          value={note}
          name="note"
          // tslint:disable-next-line:jsx-no-lambda
          onChange={e => setNote(e.target.value)}
          label={__('Poznámka')}
          maxWidthPx={400}
          marginRight={0}
        />

        <LoginButton
          type="submit"
          className="g-recaptcha"
          data-sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          data-action="submit"
          onClick={handleFormSubmit}
          disabled={!email || !name || !type}
        >
          {__('Odoslať žiadosť')}
        </LoginButton>
      </Form>
      {/* <NoAccountWrapper>
        {`${__('Nemáte účet')}? `}
        <Link to={__r('routes:registracia', '/registracia')}>
          <Register>{__('Odoslať žiadosť')}</Register>
        </Link>
      </NoAccountWrapper> */}
    </Wrapper>
  );
}

export const secondaryText = css`
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration-color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${rem(400)};
  margin: ${rem(0)} auto;
  background: ${({ theme }) => theme.colors.white};
  padding: 0 ${rem(24)} ${rem(32)};
  /* background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 4px; */

  ${({ theme }) => theme.mediab.l925`
     padding: ${rem(24)} ${rem(16)};
     margin: 0 auto;
  `}
`;

const DescText = styled(TextP)`
  margin-bottom: ${rem(32)};
`;

const Header = styled.h1`
  font-size: ${rem(30)};
  font-weight: 400;
  position: relative;
  font-family: ${({ theme }) => theme.font.primary};
  margin-bottom: ${rem(32)};
  line-height: ${rem(38)};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Form = styled.form`
  margin: 0;
  & input:first-of-type {
    margin-bottom: ${rem(16)};
  }
`;

export const LoginButton = styled(Button)`
  height: ${rem(48)};
  margin: ${rem(15)} 0 0;
  padding: ${rem(15)};
  width: 100%;
  max-width: ${rem(400)};
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  font-size: ${rem(14)};
  font-weight: 500;
  border-radius: ${rem(2)};
  margin: ${rem(32)} 0;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 4px;

  &:disabled {
    opacity: 0.5;
  }
`;

const PasswordLink = styled(Link)`
  text-decoration-color: ${({ theme }) => theme.colors.primary};
`;

const ForgotPassword = styled.p`
  ${secondaryText};
  color: ${({ theme }) => theme.colors.primary};
  text-align: right;
  margin: ${rem(16)} 0 0;
  width: 100%;
`;

export const Register = styled.p`
  ${secondaryText};
  color: ${({ theme }) => theme.colors.primary};
  text-decoration-color: ${({ theme }) => theme.colors.primary};
  display: inline-block;
  text-decoration: underline;
  margin: 0;
  margin-left: ${rem(4)};
`;

export const NoAccountWrapper = styled.span`
  ${secondaryText};
  display: flex;
  justify-content: center;
`;

// export const StyledLabel = styled.label<{ marginBottom?: number }>`
//   font-size: ${rem(16)};
//   font-weight: 400;
//   color: ${({ theme }) => theme.colors.textPrimary};
//   display: flex;
//   flex-direction: row;
//   margin-bottom: ${({ marginBottom }) =>
//     marginBottom ? rem(marginBottom) : 0};
// `;

// export const FormInput = styled(Input)<{ marginRight?: number }>`
//   width: 100%;
//   margin-top: ${rem(8)};
//   margin-right: ${({ marginRight }) => (marginRight ? rem(marginRight) : 0)};
//   font-size: ${rem(14)};
//   ${({ theme }) => theme.mediab.m600`
//     max-width: ${rem(600)};
//   `}
// `;

export { ContactForm as DsiContactForm };
